module.exports = __webpack_public_path__ + "static/img/7.c059c57.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/sp/7.png
// module id = eD0z
// module chunks = 0